
export type TypeParamParameter = typeof TypeParamParameter[keyof typeof TypeParamParameter];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TypeParamParameter = {
  FOR_YOU: 'FOR_YOU',
  USER: 'USER',
  FOLLOW: 'FOLLOW',
  DETAIL: 'DETAIL',
} as const;
